import React, { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import CategoryList from './CategoryList'
import AssetsListPage from './AssestsList'
import TDSCertificateList from './TDS'
import TrainingMainPage from './Training'

function ManageResourceMainPage() {
  const params=useParams()
  const navigate=useNavigate()

  console.log("params",params)

  const handleNavigate=(url)=>{
navigate(url)
  }

  
  return (
      <div className="pt-14 pl-5">
      <div className="bg-white flex justify-between px-8 py-2 mt-4 rounded-[10px] border overflow-auto">
        <h1 className="text-[#252C32] text-[24px]">Manage Resources </h1>
         {/* Simple Tabs Placeholder */}
      <div className="flex justify-center gap-4 ">
        <button
        onClick={()=>handleNavigate("/manage-resource/public")}
          className={`px-4 py-2 rounded ${
            params.id !== "training" && params.id !== "tds" ? "bg-blue-500 text-white" : "bg-gray-200"
          }`}
        >
          Public Collaterals
        </button>
        <button
        onClick={()=>handleNavigate("/manage-resource/training")}
          className={`px-4 py-2 rounded ${
            params.id === "training" ? "bg-blue-500 text-white" : "bg-gray-200"
          }`}
        >
          Training
        </button>
        <button
        onClick={()=>handleNavigate("/manage-resource/tds")}
          className={`px-4 py-2 rounded ${
            params.id === "tds" ? "bg-blue-500 text-white" : "bg-gray-200"
          }`}
        >
          TDS Certificate
        </button>
      </div>
      </div>
      {params?.id==="tds" ? (
        <TDSCertificateList />
      ):params?.id==="training" ? <TrainingMainPage />:params?.id ==="public" ? <CategoryList /> : params?.id ?  <AssetsListPage /> :"" }
      
    </div>
  )
}

export default ManageResourceMainPage